var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dashicons:email-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0002 14.5V5.5C19.0002 4.67 18.3302 4 17.5002 4H3.49023C2.66023 4 1.99023 4.67 1.99023 5.5V14.5C1.99023 15.33 2.66023 16 3.49023 16H17.5002C18.3302 16 19.0002 15.33 19.0002 14.5ZM17.6902 5.39C18.0202 5.72 17.8402 6.06 17.6602 6.23L13.6002 9.95L17.5002 14.01C17.6202 14.15 17.7002 14.37 17.5602 14.52C17.4302 14.68 17.1302 14.67 17.0002 14.57L12.6302 10.84L10.4902 12.79L8.36023 10.84L3.99023 14.57C3.86023 14.67 3.56023 14.68 3.43023 14.52C3.29023 14.37 3.37023 14.15 3.49023 14.01L7.39023 9.95L3.33023 6.23C3.15023 6.06 2.97023 5.72 3.30023 5.39C3.63023 5.06 3.97023 5.22 4.25023 5.46L10.4902 10.5L16.7402 5.46C17.0202 5.22 17.3602 5.06 17.6902 5.39Z",
    fill: "#F86C66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.e0ee20f005adf7e3f4759d20c0a0f3bc.svg";
export { ForwardRef as ReactComponent };